import { inject, ref } from 'vue'
import PejerBase from '..'
import { AutoCompleteManager } from '../AutoComplete'
import { Config, ConfigUrls, PejerState, TableConfig } from '../types/base'
import { defaultUrls } from './config'

export const defaultPejerState = {
  isLoading: ref(false),
  user: ref(null),
  platformInfo: ref(null),
  enviroment: ref(null),
  _currentFetch: ref(null),
  autoComplete: new AutoCompleteManager(),
  data: {},
  settings: {},
} satisfies PejerState

export const PROVIDER_KEY = 'pejer'

export const _pejerProvider = async <
  L extends TableConfig,
  U extends ConfigUrls,
  O extends Config<U, L>,
  P extends PejerBase<L, U, O>,
>(
  pejer: P,
  config: O
) => {
  return {
    key: PROVIDER_KEY,
    provider: await pejer.setConfig(config).init(),
  }
}

export const usePejerBase = <L extends TableConfig, U extends ConfigUrls>(): PejerBase<
  L,
  typeof defaultUrls
> => {
  const val = inject(PROVIDER_KEY)
  if (!val) {
    throw new Error('No Pejer provider found')
  }
  return val as PejerBase<L, typeof defaultUrls>
}
